var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "comment__item",
      class: _vm.showAsDeleted ? "deleted" : "",
      attrs: { id: "c-" + _vm.comment.id, "data-id": _vm.comment.id }
    },
    [
      _c(
        "div",
        { class: _vm.comment.isNew ? "is-new" : "" },
        [
          _c("post-author", { attrs: { comment: _vm.comment } }),
          _vm._v(" "),
          _c(
            "p",
            { ref: "commentBody", staticClass: "comment__item__content" },
            [
              _vm.showAsDeleted
                ? _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "javascript.video.action.conversations.delete_confirmation"
                        )
                      )
                    )
                  ])
                : _c("truncate", {
                    attrs: {
                      height: 60,
                      more: _vm.$t("javascript.readmore.more"),
                      less: _vm.$t("javascript.readmore.less"),
                      html: _vm.processedCommentBody,
                      "post-processing-fn": _vm.processBody,
                      autolink: ""
                    }
                  })
            ],
            1
          ),
          _vm._v(" "),
          !_vm.showAsDeleted
            ? _c("div", { staticClass: "comment__item__button-group" }, [
                !_vm.comment.deleted
                  ? _c(
                      "button",
                      {
                        staticClass: "vs-btn btn comment__item__recommend",
                        attrs: { "data-id": _vm.comment.id },
                        on: {
                          click: function($event) {
                            return _vm.executeWithGuard("recommendVideo")
                          }
                        }
                      },
                      [
                        _c("i", { staticClass: "fa fa-thumbs-o-up" }),
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.likesWithLocale) +
                            "\n      "
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "vs-btn btn comment__item__reply",
                    attrs: {
                      "data-reply-to": _vm.comment.parent_id
                        ? _vm.comment.parent_id
                        : _vm.comment.id
                    },
                    on: {
                      click: function($event) {
                        return _vm.executeWithGuard("toggleReplyBox")
                      }
                    }
                  },
                  [
                    _c("i", { staticClass: "fa fa-reply" }),
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t("video.action.conversations.reply")) +
                        "\n      "
                    )
                  ]
                ),
                _vm._v(" "),
                _vm.permission.admin || _vm.permission.isDeletable
                  ? _c(
                      "button",
                      {
                        staticClass: "vs-btn btn comment__item__delete",
                        attrs: { "data-id": _vm.comment.id },
                        on: {
                          click: function($event) {
                            return _vm.executeWithGuard("promptForDeletion")
                          }
                        }
                      },
                      [
                        _c("i", { staticClass: "fa fa-trash-o" }),
                        _vm._v(
                          "\n        " +
                            _vm._s(
                              _vm.$t("video.action.conversations.delete.header")
                            ) +
                            "\n      "
                        )
                      ]
                    )
                  : _vm._e()
              ])
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c("post-reply-box", {
        ref: "commentReplyBox",
        attrs: {
          user: _vm.user,
          "video-id": _vm.videoId,
          "reply-id": _vm.comment.parent_id
            ? _vm.comment.parent_id
            : _vm.comment.id
        },
        on: { success: _vm.updateParent }
      }),
      _vm._v(" "),
      _vm._l(_vm.commentReplies, function(reply) {
        return _c("comment-post", {
          key: reply.id,
          attrs: { comment: reply, user: _vm.user, "video-id": _vm.videoId },
          on: { success: _vm.updateParent }
        })
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }